import { render, staticRenderFns } from "./a11y-modal.vue?vue&type=template&id=610f718c"
import script from "./a11y-modal.vue?vue&type=script&lang=js"
export * from "./a11y-modal.vue?vue&type=script&lang=js"
import style0 from "./a11y-modal.vue?vue&type=style&index=0&id=610f718c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports